/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import Tooltip from 'components/tooltip/Tooltip';
import { Glyphicon } from 'react-bootstrap';
import CountrySelectField from 'components/forms/countrySelectField/CountrySelectField';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';
import { PreArrivalFormFields } from '../../PreArrivalFormTab.types';
import useShouldShowField from '../useShouldShowField';
import {
  OtherGuestFieldsContainer,
  PreviewRow,
  OtherGuestInfoContainer,
  PreviewDivider,
} from '../PreviewPreArrivalForm.styles';
import GovernmentIdFileField from '../fields/GovernmentIdFileField';

const OtherGuestInformationSection = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  const { shouldShowField } = useShouldShowField();

  // this should will be always bigger than 2, because the primary guest is the first one
  const previewNumberOfGuests = watch('preview.howManyGuests');

  return (
    <>
      <OtherGuestInfoContainer data-testid="preview-other-guest-information-section">
        <h2>
          {t('pageAutomations.preArrivalForm.preview.otherGuestInfo.header')}
        </h2>

        {Array.from(
          { length: (previewNumberOfGuests || 2) - 1 },
          (_, index) => (
            <OtherGuestFieldsContainer key={index}>
              <h3>
                {t(
                  'pageAutomations.preArrivalForm.preview.otherGuestInfo.guestNumber',
                  {
                    number: index + 2,
                  },
                )}
              </h3>

              <PreviewRow columns={5}>
                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_FIRST_NAME,
                  <TextField
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].firstName`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.firstName',
                    )}
                  />,
                )}

                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_LAST_NAME,
                  <TextField
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].lastName`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.lastName',
                    )}
                  />,
                )}

                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_EMAIL,
                  <TextField
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].email`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.email',
                    )}
                  />,
                )}

                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_PHONE_NUMBER,
                  <TextField
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].phoneNumber`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.phoneNumber',
                    )}
                  />,
                )}

                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_AGE,
                  <TextField
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].age`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.age',
                    )}
                  />,
                )}
              </PreviewRow>

              <PreviewRow>
                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_GOVERNMENT_ID,
                  <GovernmentIdFileField
                    name={`preview.otherGuests[${index}].governmentIdFile`}
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.governmentIdFile',
                    )}
                  />,
                )}

                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_GOVERNMENT_ID,
                  <CountrySelectField
                    rightTooltip={t(
                      'pageAutomations.preArrivalForm.preview.governmentId.countryTooltip',
                    )}
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].governmentIdCountry`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.governmentIdCountry',
                    )}
                  />,
                )}

                {shouldShowField(
                  PreArrivalFormFields.OTHER_GUEST_GOVERNMENT_ID,
                  <TextField
                    rightTooltip={t(
                      'pageAutomations.preArrivalForm.preview.governmentId.numberTooltip',
                    )}
                    colSmInput={12}
                    name={`preview.otherGuests[${index}].governmentIdNumber`}
                    labelOnTop
                    label={t(
                      'pageAutomations.preArrivalForm.preview.otherGuestInfo.governmentIdNumber',
                    )}
                  />,
                )}
              </PreviewRow>
            </OtherGuestFieldsContainer>
          ),
        )}

        <CheckboxField name="preview.sendPlannedTripInfo">
          <span>
            {t(
              'pageAutomations.preArrivalForm.preview.otherGuestInfo.sendPlannedTripInfo',
            )}
          </span>
          <Tooltip
            id="sendPlannedTripInfoTooltip"
            text={
              <Trans
                i18nKey="pageAutomations.preArrivalForm.preview.otherGuestInfo.sendPlannedTripInfoTooltip"
                components={{
                  1: (
                    <a
                      href="https://help.hostfully.com/en/articles/2434707-understand-system-templates#h_fb0ad2757d"
                      target="_blank"
                      rel="noreferrer"
                    />
                  ),
                }}
              />
            }
          >
            <Glyphicon glyph="info-sign" />
          </Tooltip>
        </CheckboxField>
      </OtherGuestInfoContainer>

      <PreviewDivider />
    </>
  );
};

export default OtherGuestInformationSection;
